// extracted by mini-css-extract-plugin
export default {"container":"styles_container__0MMxv","title":"styles_title__ywOio","grid":"styles_grid__Itxf7","card":"styles_card__nMXh+"};